import React from 'react';
import { useTranslation } from 'react-i18next';

import GenericPaymentMethod from './GenericPaymentMethod';
import CheckIcon from 'components/Common/Icons/Check';
import Trans from 'components/Common/Translation/Trans';
import PaymentMethod from 'model/PaymentMethod';
import useEnv from 'hooks/useEnv';
import { MethodProps } from 'types/PaymentFormType';

import styles from './PaymentMethod.module.scss';

export default function PaPaymentMethod({
  handleClick,
}: MethodProps): JSX.Element {
  const { t } = useTranslation(['checkout']);
  const { mediaPopin } = useEnv();

  return (
    <>
      <GenericPaymentMethod
        value={PaymentMethod.pa}
        isDisabled
        classes={{
          methodTitle: styles.personalAccountMethodTitle,
          methodContent: styles.personalAccountMethodContent,
        }}
        labelContent={
          <>
            <span className={styles.methodLogo}>
              <CheckIcon />
            </span>
            <span className={styles.methodText}>{t('PA_METHOD_TITLE')}</span>
          </>
        }
      >
        <div className={styles.qeMethodContentContainer}>
          <div>
            <Trans
              i18nKey={'PA_METHOD_INFORMATION'}
              namespace={'checkout'}
              additionalComponents={{
                findOutMoreLink: (
                  <a
                    className={styles.seeMore}
                    href={`${mediaPopin}/16.html`}
                    onClick={handleClick}
                  />
                ),
              }}
            />
          </div>
        </div>
      </GenericPaymentMethod>
      <p className={styles.paDisableExplain}>
        <Trans i18nKey={'PA_METHOD_DISABLE_EXPLAINS'} namespace={'checkout'} />
      </p>
    </>
  );
}
